import React, { Suspense, useEffect, useId, useRef } from "react";

import UnsuitableReasonModalContainer from "@/components/shared/business/UnsuitableReason/components/UnsuitableReasonModalContainer/UnsuitableReasonModalContainer";

import * as S from "./UnsuitableCheckboxIcon.style";
import { MODAL_POSITION_BY_USAGE_TYPE } from "../../../UnsuitableReason/constants/unsuitableReason.constants";
import { UnsuitableReasonUsageType } from "../../../UnsuitableReason/types/unsuitableReason.types";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  isChecked: boolean;
  draftArticleId: number;
  isOpenModalUnsuitablePress: boolean;
  articleRejectReason: string | null;
  closeModalUnsuitablePress: () => void;
  openModalUnsuitablePress: () => void;
  mcEditorName: string | null;
  aiDone: boolean;
  unsuitableReasonUsageType: UnsuitableReasonUsageType;
}

const UnsuitableCheckboxIcon = ({
  isChecked,
  draftArticleId,
  isOpenModalUnsuitablePress,
  articleRejectReason,
  closeModalUnsuitablePress,
  openModalUnsuitablePress,
  unsuitableReasonUsageType,
  ...rest
}: Props) => {
  const checkboxId = useId();
  const checkboxRef = useRef<HTMLDivElement>(null);

  const handleCheckboxClick = () => {
    if (isOpenModalUnsuitablePress) {
      closeModalUnsuitablePress();
    } else {
      openModalUnsuitablePress();
    }
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isClickInside = checkboxRef.current?.contains(target);
      const isDeleteButton = target.dataset.button;

      if (isClickInside || isDeleteButton) return;

      if (isOpenModalUnsuitablePress) {
        closeModalUnsuitablePress();
      }
    };

    window.addEventListener("click", handleClickOutside);

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [isOpenModalUnsuitablePress, closeModalUnsuitablePress]);

  return (
    <div ref={checkboxRef}>
      <S.CheckboxLabel htmlFor={checkboxId} onClick={handleCheckboxClick}>
        <S.CheckboxInput
          id={checkboxId}
          type="checkbox"
          checked={isChecked}
          {...rest}
        />
        {articleRejectReason || "-"}
      </S.CheckboxLabel>
      <Suspense>
        {isOpenModalUnsuitablePress && (
          <UnsuitableReasonModalContainer
            closeModalUnsuitablePress={closeModalUnsuitablePress}
            articleRejectReason={articleRejectReason}
            draftArticleId={draftArticleId}
            unsuitableReasonUsageType={unsuitableReasonUsageType}
            isOpenModalUnsuitablePress={isOpenModalUnsuitablePress}
            modalPosition={
              MODAL_POSITION_BY_USAGE_TYPE[unsuitableReasonUsageType]
            }
          />
        )}
      </Suspense>
    </div>
  );
};

export default UnsuitableCheckboxIcon;
